import { AEMModelAssets } from './tracker/constants';
import { getCtaText } from './getCtaText';
import { CT_PERSONALIZATION_TYPES, CT_PERSONALIZATION_CTA_TEXT } from './constants';

export const getFallbackTiles = (tiles) => {
  const toReturn = tiles
    .filter((tile) => tile.isDefault === true)
    .map((tile) => ({
      ...tile,
      tileType: CT_PERSONALIZATION_TYPES.mlp,
      CTA: {
        ...tile.CTA,
        text: `${CT_PERSONALIZATION_CTA_TEXT.mlp} ${tile.heading.text}`,
      },
    }));
  // NOTE: since this is the fallback tiles `isPersonalized === false`
  return toReturn.length === 0
    ? {
        isPersonalized: false,
        tiles,
      }
    : {
        isPersonalized: false,
        tiles: toReturn,
      };
};
export const getPersonalizedTiles = ({
  personalizedResults,
  tiles,
  personalizationData,
  debug,
}) => {
  const textNewBuild = 'Start a new build';
  const textResumeBuild = 'Continue your build';
  const textNonBuild = '';
  const subHeading = {
    text: '',
    variant: 'order3',
    htmlTag: 'p',
  };
  // START: For Content Authors to debug Tile Content
  if (debug && personalizationData) {
    // set all to true
    const { tiles: originalTiles } = personalizationData;
    if (debug === CT_PERSONALIZATION_TYPES.MLP) {
      // change cta
      // change href
      const tileData = originalTiles.map((tile) => {
        return {
          ...tile,
          isDefault: true,
          tileType: CT_PERSONALIZATION_TYPES.MLP,
          CTA: {
            ...tile.CTA,
            text: `Explore ${tile.heading.text.replace(/^Audi /, '')}`,
          },
        };
      });
      return {
        isPersonalized: true,
        tiles: tileData,
      };
    }
    if (
      debug === CT_PERSONALIZATION_TYPES.NEW_BUILD ||
      debug === CT_PERSONALIZATION_TYPES.RESUME_BUILD
    ) {
      // change cta
      // change href
      const tileData = originalTiles.map((tile) => {
        return {
          ...tile,
          isDefault: true,
          tileType: CT_PERSONALIZATION_TYPES.NEW_BUILD,
          subHeading: {
            ...subHeading,
            text: debug === CT_PERSONALIZATION_TYPES.NEW_BUILD ? textNewBuild : textResumeBuild,
          },
          CTA: {
            ...tile.CTA,
            text: `Build ${tile.heading.text.replace(/^Audi /, '')}`,
            href: `${tile.CTA.href}build/`,
          },
        };
      });
      return {
        isPersonalized: true,
        tiles: tileData,
      };
    }
  }
  // END: For Content Authors to debug Tile Content
  const tileData = personalizationData?.tiles || tiles;
  if (personalizedResults) {
    const modelNames = Object.keys(personalizedResults).splice(0, 3);
    const filteredTiles = tileData.filter((tile) => {
      return modelNames.includes(tile.heading.text);
    });

    if (filteredTiles.length > 0) {
      const modelNamesOfficialObj = Object.values(personalizedResults).splice(0, 3);
      let tileIndex = 0;
      const toReturn = {
        isPersonalized: true,
        tiles: modelNamesOfficialObj.map((item) => {
          const tile = filteredTiles.find(
            (ct) => ct.heading.text === `Audi ${AEMModelAssets[item.modelName]}`,
          );
          if (tile) {
            const tileType = personalizedResults[`Audi ${AEMModelAssets[item.modelName]}`].type;
            const ctaText = getCtaText(tileType, `${AEMModelAssets[item.modelName]}`);
            let { href } = tile.CTA;
            let textSubheading = '';
            if (tileType === CT_PERSONALIZATION_TYPES.RESUME_BUILD) {
              href = personalizedResults[`Audi ${AEMModelAssets[item.modelName]}`].url;
              textSubheading = textResumeBuild;
            }
            if (tileType === CT_PERSONALIZATION_TYPES.NEW_BUILD) {
              href = `${tile.CTA.href}build/`;
              textSubheading = textNewBuild;
            }

            if (tileIndex !== 0) {
              textSubheading = textNonBuild;
            }
            tileIndex += 1;
            return {
              ...tile,
              tileType,
              subHeading: {
                ...subHeading,
                text: textSubheading,
              },
              CTA: {
                ...tile.CTA,
                text: ctaText,
                href,
              },
            };
          }
          return undefined;
        }),
      };
      return toReturn;
    }
    return getFallbackTiles(tileData);
  }

  return getFallbackTiles(tileData);
};
